import { useState, useEffect } from 'react';
import { ArrowRight } from 'lucide-react';

export const StickyCTA = ({ onCtaClick }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling 400px
      const scrollY = window.scrollY;
      setIsVisible(scrollY > 400);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={`sticky-cta ${isVisible ? 'visible' : ''}`} data-testid="sticky-cta">
      <div className="container-custom">
        <button
          onClick={onCtaClick}
          className="btn-cta w-full text-base"
          data-testid="sticky-cta-button"
        >
          Få kostnadsfri offert
          <ArrowRight className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default StickyCTA;
